export default __webpack_public_path__ + "static/media/snp-qtl.532ae331.png";